import { createRouteRef } from "@backstage/core-plugin-api";

export const explorerRouteRef = createRouteRef({
  id: "cloudhealth-explorer",
});
